<template>
  <div>
    <h1 v-if="formId === 'full-form-kaffeemaschinenberater'">{{ headline }}</h1>
    <form
      class="form-inline"
      data-form-type="machine-advisor"
      action="/api/index.php"
      :id="formId"
      novalidate="novalidate"
    >
      <div v-if="formId === 'fallback-form-kaffeemaschinenberater'" class="row">
        <div class="col-xs-12">
          <div class="small-form-headline">
            <h1>{{ headline }}</h1>
            <h2>
              Auf Grundlage Ihrer Auswahl ist es einfacher wenn wir
              maßgeschneidert Lösungen suchen und persönlich mit Ihnen
              sprechen.<br />Füllen Sie dazu bitte noch die Informationen aus.
            </h2>
          </div>
        </div>
      </div>
      <div class="row error-header-wrapper hidden">
        <div class="col-xs-12">
          <div class="error-header">
            Hoppla, das Absenden des Formulars war nicht möglich.<br />Bitte
            überprüfen Sie Ihre Angaben.
          </div>
        </div>
      </div>
      <label class="hidden-label" :for="formId + '-additional-information'"
        >Zusätzliche Daten</label
      >
     

      <input
        type="text"
        :name="formId + '-additional-information'"
        class="form-control hidden"
        :id="formId + '-additional-information'"
        :value="resultData"
      />

       <input
        type="hidden"
        :name="formId + '-campaignonlineid'"
        class="form-control form-campaignonlineid hidden"
        :id="formId + '-form-campaignonlineid'"
        value="ib-jks-maschinenberater"
      />

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label class="hidden-label" :for="formId + '-company'">Firma</label>
            <input
              type="text"
              :name="formId + '-company'"
              autocomplete="organization"
              class="form-control form-company"
              :id="formId + '-company'"
              data-ga="companyName"
              placeholder="Ihre Firma"
              data-rule-required="true"
              data-field-type="companyName"
              data-msg-required="Bitte geben Sie Ihre Firma ein"
            />
          </div>
        </div>
        <div class="col-xs-12">
          <div class="form-group">
            <label class="hidden-label" :for="formId + '-name'">Ihr Name</label>
            <input
              type="text"
              :name="formId + '-name'"
              autocomplete="name"
              class="form-control form-name"
              :id="formId + '-name'"
              data-ga="name"
              placeholder="Ihr Name"
              data-rule-required="true"
              data-field-type="name"
              data-msg-required="Bitte geben Sie Ihren Namen ein"
            />
          </div>
        </div>
        <div class="col-xs-12">
          <div class="form-group">
            <label class="hidden-label" :for="formId + '-email'"
              >Ihre E-Mail-Adresse</label
            >
            <input
              type="email"
              :name="formId + '-email'"
              autocomplete="email"
              class="form-control form-email"
              :id="formId + '-email'"
              data-ga="mailAddress"
              placeholder="Ihre E-Mail-Adresse"
              data-rule-required="true"
              data-rule-email="true"
              data-field-type="email"
              data-msg-required="Bitte geben Sie Ihre E-Mail-Adresse ein"
              data-msg-email="Bitte geben Sie eine korrekte E-Mail-Adresse ein"
            />
          </div>
        </div>
        <div v-if="hidePhoneNumber === false" class="col-xs-12">
          <div class="form-group">
            <label class="hidden-label" :for="formId + '-number'"
              >Ihre Telefonnummer</label
            >
            <input
              type="text"
              :name="formId + '-number'"
              autocomplete="tel"
              class="form-control form-phone"
              :id="formId + '-number'"
              data-ga="phoneNumber"
              placeholder="Ihre Telefonnummer"
              data-rule-required="true"
              data-rule-phone="true"
              data-field-type="phone"
              data-msg-required="Bitte geben Sie Ihre Telefonnummer ein"
              data-msg-phone="Bitte geben Sie eine korrekte Telefonnummer ein"
            />
          </div>
        </div>
        <div v-if="hideMessage === false" class="col-xs-12">
          <div class="form-group">
            <textarea
              cols="50"
              rows="4"
              :name="formId + '-message'"
              class="form-control form-message"
              data-ga="Ihre Nachricht"
              :id="formId + '-message'"
              placeholder="Ihre Nachricht"
              data-rule-required="false"
              data-field-type="comment"
              data-msg-required="Bitte tragen Sie eine Nachricht ein"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row centered">
        <div class="col-xs-12">
          <div class="form-data-privacy-text">
            Ihre oben angegebenen Daten werden ausschließlich zur Bearbeitung
            Ihrer Anfrage gespeichert. Die Daten werden nicht an Dritte
            weitergegeben. Sie werden gelöscht, sobald Ihre Kenntnis für die
            Bearbeitung Ihrer Anfrage nicht mehr erforderlich ist.
          </div>
        </div>
      </div>
      <div v-if="hidePrevButton === false" class="prev-button-wrapper form-prev-buttom">
        <div
          @click="prevButton()"
          class="prev-button form-prev"
          ref="prev-button"
          :data-page="survey.currentPage.name"
          :data-test="survey.currentPage.getValue()[survey.currentPage]"
        >
          <i class="icon icon-angle-down arrow-left"></i> 
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="link-block type-green-with-line">
            <div class="button-link">
              <button :id="formId + '-send-form'" type="submit">
                {{ buttonText }}
              </button>
              <div class="error-header-api hidden">
                Hoppla, das Absenden des Formulars war nicht möglich.<br />Bitte
                versuchen Sie es später.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="info-icons">
            <img src="/images/default/badge-SSL.png">
            <img src="/images/default/badge-35k.png">
            <img src="/images/default/badge-810.png">
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import CalenderModul from './CalenderModul'

export default {
  components: {
    // CalenderModul
  },
  data() {
    return {
      dateValue: null,
      lang: {
        // the locale of formatting and parsing function
        formatLocale: {
          months: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
          ],
          monthsShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'Mai',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dez',
          ],
          weekdays: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
          ],
          weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          weekdaysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          firstDayOfWeek: 1,
          firstWeekContainsDate: 1,
          use12h: false,
        },
        yearFormat: 'YYYY',
        monthFormat: 'MMM',
      },
    }
  },
  props: {
    formId: {
      type: String,
      default: '',
      validator: function(value) {
        return [
          'fallback-form-kaffeemaschinenberater',
          'full-form-kaffeemaschinenberater',
        ].includes(value)
      },
    },
    buttonText: {
      type: String,
      default: '',
    },
    hideCompany: {
      type: Boolean,
      default: false,
    },
    hideName: {
      type: Boolean,
      default: false,
    },
    hideEmail: {
      type: Boolean,
      default: false,
    },
    hidePhoneNumber: {
      type: Boolean,
      default: false,
    },
    hideMessage: {
      type: Boolean,
      default: false,
    },
    hidePrevButton: {
      type: Boolean,
      default: false,
    },
    showInformationBlock: {
      type: Boolean,
      default: false,
    },
    resultData: {
      type: String,
      default: '',
    },
    survey: {
      type: Object,
      default: () => {},
    },
    headline: {
      type: String,
      default: '',
    },
  },
  methods: {
    prevButton() {
      this.survey.clear(false, false)
      this.$emit('prevButton', 'form')
    }
  },
}
</script>
